/**
 * Query key factory for AWNewsServer TanStack Query wrappers.
 *
 * Convention: [domain, ...identifiers, ...dependencies]
 * All keys must be deterministic and use primitive values only.
 */

import type { NewsQueryKeys } from './types';

export const newsQueryKeys: NewsQueryKeys = {
  article: (params) => ['news', 'article', params],
};
